window.addEventListener('DOMContentLoaded', () => {
  const shareButtons = document.querySelectorAll('.social-media-sharer .btn-share');
  const shareApiButton = document.querySelector('.social-media-sharer .btn-share-webapi');
  const shareUrl = encodeURIComponent(window.location.href);
  const shareTitle = encodeURIComponent(document.querySelector('.news-detail__header').innerText);

  shareButtons.forEach(button => {
    button.addEventListener('click', event => {
      event.preventDefault();
      const shareNetwork = button.dataset.network;
      let shareLink = '';

      switch (shareNetwork) {
        case 'instagram':
          shareLink = `https://www.instagram.com/?url=${shareUrl}`;
          break;
        case 'facebook':
          shareLink = `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`;
          break;
        case 'twitter':
          shareLink = `https://twitter.com/intent/tweet?url=${shareUrl}&text=${shareTitle}`;
          break;
        case 'xing':
          shareLink = `https://www.xing.com/spi/shares/new?url=${shareUrl}`;
          break;
        case 'linkedin':
          shareLink = `https://www.linkedin.com/shareArticle?mini=true&url=${shareUrl}&title=${shareTitle}`;
          break;
        case 'mail':
          shareLink = `mailto:?subject=${shareTitle}&body=${shareUrl}`;
          window.open(shareLink, '_blank');
          break;
        case 'clipboard':
          navigator.clipboard.writeText(window.location.href);
          break;
        default:
          break;
      }

      if(shareNetwork !== 'mail' && shareNetwork !== 'clipboard') {
        window.open(shareLink, 'Share', 'width=600,height=400');
      }
    });
  });

  if (navigator.share) {
    shareButtons.forEach(button => {
      button.closest('li').classList.add('d-none','d-md-block');
    });
    shareApiButton.closest('li').classList.add('d-md-none');
    shareApiButton.addEventListener('click', async () => {
      try {
        await navigator.share({
          title: document.title,
          url: window.location.href
        });
      } catch (err) {
        console.error('navigator.share error', err);
      }
    });
  } else {
    shareApiButton.closest('li').remove();
  }
});
